import React, { useEffect, useState } from "react";

import "./dashboardWrapper.css";
import HeaderLink from "../../pageparts/header/headerLink";
import useWindowDimensions from "../../utils/useWindowDimensions";
import BurgerIcon from "../../assets/icons/burgerIcon";
import ChevronIcon from "../../assets/icons/chevronIcon";
import LogoutIcon from "../../assets/icons/instruments/logoutIcon";
import { Helmet } from "react-helmet";
import { useDashboardContext } from "../../context/dashboardContext";

interface DashboardWrapperProps {
    children: any;
    className?: string;
}

export default function DashboardWrapper(props: DashboardWrapperProps) {

    const {isAdmin} = useDashboardContext();

    const windowDimensions = useWindowDimensions();

    const [activeName, setActiveName] = useState("");
    const [mobileOpen, setMobileOpen]= useState(false);

    function updateActiveName(v: string) {
        if(v === activeName) return;
        setActiveName(v);
        setMobileOpen(false);
    }

    return <div className={"dashboard no-footer keep-margin page flex" + (windowDimensions.width >= 1050 ? " has-sidebar" : "") + (props.className ? " " + props.className : "")}>
        <Helmet>
            <meta name="robots" content="noindex"/>
            <meta name="googlebot" content="noindex"/>
        </Helmet>
        <div className="burger">
            <div className="icon" onClick={() => {
                setMobileOpen(!mobileOpen);
            }}>
                <BurgerIcon/>
            </div>
            <h3>{activeName}</h3>
        </div>
        <ul className={"sidebar navigation" + (windowDimensions.width < 1050  ? " mobile" : "") + (mobileOpen ? " expanded" : "")}>
            <div className="collapse" onClick={() => {
                setMobileOpen(!mobileOpen);
            }}>
                <ChevronIcon/>
            </div>
            <HeaderLink navigate setActiveName={updateActiveName} link="dashboard/overview" name="Overview"/>
            <HeaderLink navigate setActiveName={updateActiveName} link="dashboard/history" name="History"/>
            <HeaderLink navigate setActiveName={updateActiveName} link="dashboard/liked" name="Liked"/>
            <HeaderLink navigate setActiveName={updateActiveName} link="dashboard/bookmarked" name="Bookmarked"/>
            <HeaderLink navigate setActiveName={updateActiveName} link="dashboard/mypieces" name="My Pieces"/>
            <HeaderLink navigate setActiveName={updateActiveName} link="dashboard/profile" name="Profile"/>
            <HeaderLink navigate setActiveName={updateActiveName} link="dashboard/settings" name="Settings"/>
            {
                isAdmin ? <>
                <HeaderLink navigate className="admin" setActiveName={updateActiveName} link="dashboard/admin/pieces" name="Pieces"/>
                <HeaderLink navigate className="admin" setActiveName={updateActiveName} link="dashboard/admin/payouts" name="Payouts"/>
                <HeaderLink navigate className="admin" setActiveName={updateActiveName} link="dashboard/admin/purchases" name="Purchases"/>
                <HeaderLink navigate className="admin" setActiveName={updateActiveName} link="dashboard/admin/accounts" name="Accounts"/>
                <HeaderLink navigate className="admin" setActiveName={updateActiveName} link="dashboard/admin/artists" name="Artists"/>
                </> : <></>
            }
            <li className="logout" onClick={() => {
                window.location.href = "/logout";
            }}>
                <h3>Log out<LogoutIcon/></h3>
            </li>
        </ul>
        <div className="dashboard-children">
            {props.children}
        </div>
    </div>
}